import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";

export default function ProtectedRoute({ children, requireOnboarded = true }) {
  const { user, loading, authError, retryAuth } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-canvas flex items-center justify-center">
        <div className="h-10 w-10 rounded-full border-2 border-navy/15 border-t-navy animate-spin" />
      </div>
    );
  }
  if (!user && authError) {
    // /auth/me failed for a reason other than "not signed in" (offline,
    // timeout, server hiccup): the user may well be signed in, so don't send
    // them to /login. Offer a retry instead.
    return (
      <div className="min-h-screen bg-canvas flex items-center justify-center px-6" data-testid="auth-unreachable">
        <div className="text-center max-w-sm">
          <p className="font-heading font-semibold text-ink text-[20px]">Can't reach GuMi right now</p>
          <p className="mt-2 font-body text-[14px] text-ink-soft leading-[1.6]">
            Check your connection and try again. You haven't been signed out.
          </p>
          <button
            type="button"
            onClick={retryAuth}
            data-testid="auth-retry"
            className="mt-5 rounded-full bg-navy text-white px-6 py-3 font-body text-[13px] font-medium hover:bg-navy-hover transition-colors"
          >
            Try again
          </button>
        </div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  // The 3-step onboarding wizard is gone — the resume upload page is the
  // only onboarding now. /profile/resume itself passes requireOnboarded={false}
  // (see App.js), so this never loops back onto itself.
  if (requireOnboarded && !user.onboarded && !user.active_profile_id) {
    return <Navigate to="/profile/resume" replace />;
  }
  return children;
}
